import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportPanelDirective } from './report-panel.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ReportPanelDirective],
  exports: [ReportPanelDirective]
})
export class ReportPanelModule {
}
